import React, { Component } from 'react';

import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import Switch from "react-switch";

import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultaOferta } from '../../funciones/OfertaFunction';

import OfertaTable from './OfertaTable';

class Oferta extends Component {
    state = {
        valorSemestre: { value: '', label: '- Selecciona un Nivel -' },
        semestres: [{ value: '', label: ' - Cargando Espere - ', num: '' }],
        secciones: [],
        preloader:{ icon: "", text: "" },
        textTable: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando Secciones. Espera</React.Fragment>,
        profesores: [{ value: '', label: ' - Cargando Espere - ', num: '' }]
    }

    componentWillMount = () => {
        this.setState({profesores: this.props.profesores})
        this.setState({semestres: this.props.semestres})
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            preloader:{ icon: "fa fa-spinner fa-spin" },
        }, () => {
            ConsultaOferta (valorSemestre.value, (resp) => {
                if (resp.length === 0) {
                    this.setState ({
                        secciones: resp,
                        preloader:{ icon: "", text: "" },
                        textTable: "No hay secciones disponibles para este periodo",
                    })
                }else{
                    this.setState ({
                        secciones: resp,
                        preloader:{ icon: "", text: "" },
                        textTable: "",
                    })
                }
                
            })
        });
    }
    change = () => {

    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12} align="justify">
                        En este módulo podrás aperturar la oferta académica del periodo. Antes de este paso, asegúrate de haber 
                        cargado <strong>Todas las Secciones</strong> correctamente desde la opción <strong style={{color:"#1f2f6e"}}>
                        Registrar Secciones</strong> de la parte superior de esta ventana.
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        Selecciona un nivel para ver las secciones disponibles. En caso de no tener registrada ninguna aparecerá 
                        un mensaje como este: <strong>No existen secciones registradas</strong>
                    </Col>
                </Row>
                <Row  className="custom-mt-10">
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        Verás un listado con todas las secciones disponibles, las cuales deberás agregar el Periodo o Cohorte.
                    </Col>
                    <Col md={12} align="justify">
                        También podrás cambiar el profesor si fuese necesario simplemente eligiendo el nuevo profesor de la lista.
                    </Col>
                </Row>
                <Row className="custom-mt-10">
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        Para habilitar la sección debes hacer click en el botón <Switch height={12} onChange={this.change} width={24} checked={false} /> y este cambiará su
                        Status a <Switch height={12} onChange={this.change} width={24} checked={true} /> indicándote que la sección fue aperturada y estará disponible para los
                        estudiantes
                    </Col>
                    <Col md={12} align="justify" style ={{fontSize:11}} className="custom-mt-10">
                        <strong>Importante: debes esperar que el icono de la izquierda cambie de <i className="fa fa-spinner fa-spin"></i> a 
                        <i className="fa fa-check"></i></strong>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    contenido = () => {
        let { valorSemestre, secciones, profesores, preloader } = this.state;
        if (valorSemestre.value === "") return(
            <div align="center" className="custom-mt-20">Seleccione un Nivel</div>
        )

        const styles = {
            padding: 5, fontSize: 12
        }

        let ContenidoSec = () => {
            let { textTable } = this.state;
            if(secciones.length === 0) return (
                <tr>
                    <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                        {textTable}
                    </td>
                </tr>
            )

            let time = 0;
            return (
                secciones.map(option => {
                    time += 1000;
                    return (<OfertaTable key={ option.id } time =  {time} profes = { profesores } campos={ option }/>)
                })
            )
        }

        return (
            <React.Fragment>
                <div className="text-danger" align="center">{valorSemestre.label} <i className={preloader.icon}></i></div>
                <div className="table-responsive">
                    <Table striped hover bordered>
                        <tbody>
                            <tr>
                                <td colSpan={2} width="40%" style={styles} align= "center"><strong>Sección</strong></td>
                                <td width="35%" style={styles} align= "center"><strong>Profesor</strong></td>
                                <td width="25%" style={styles} align= "center"><strong>Periodo</strong></td>
                                <td width="15px" style={styles} align= "center"><strong>Status</strong></td>
                            </tr>
                            {ContenidoSec()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    render() {
        let { semestres, valorSemestre, preloader} = this.state;
        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
        });
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-success" style={{padding: 5}}>
                            <Row>
                                <Col md={7} style={{paddingTop: 10}}>
                                    <i className={preloader.icon}></i> Selecciona un nivel para continuar
                                </Col>
                                <Col md={5}>
                                    <Select
                                        styles={{menu: customStyles}}
                                        isSearchable ={true}
                                        value={valorSemestre}
                                        onChange={this.valorSelectSemestre}
                                        options={semestres}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <Row className="custom-mt-10">
                            <Col md={12}>{this.contenido()}</Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Oferta Académica</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Oferta;


// WEBPACK FOOTER //
// ./src/views/Secciones/Oferta.jsx